<h2 class="mb-2">Zugriff verweigert</h2>
<div class="mt-4 alert alert-danger">
  Sie besitzen leider nicht die Rechte welche notwendig sind um diese Ressource
  anzuzeigen.
</div>
